/**
 * Asset Image URL Utility
 * 
 * Gets URLs for asset type images.
 * 
 * Priority:
 * 1. Full URLs (GCS, etc.) - pass through unchanged
 * 2. Local public folder with URL-safe filenames
 */

// Map filenames with special characters to URL-safe versions
// Only map files that actually exist with underscores on disk
// Files with spaces will be URL-encoded by encodeURIComponent
const FILENAME_MAP = {
  // Only include mappings for files that actually exist with underscores
  // Files with spaces will be properly URL-encoded
};

// Fallback simple filenames that are known to work (no special chars)
const FALLBACK_IMAGE = 'Pallets.png';

/**
 * Get the public URL for an asset image
 * 
 * @param {string} filenameOrUrl - The image filename (e.g., 'Racks.png') or full URL
 * @returns {string} - The full URL to the image
 */
export function getAssetImageUrlFromClient(filenameOrUrl) {
  if (!filenameOrUrl || filenameOrUrl.trim() === '') {
    return `/asset_images/${FALLBACK_IMAGE}`;
  }

  // If it's already a full URL (from GCS or other storage), return as-is
  if (filenameOrUrl.startsWith('http://') || filenameOrUrl.startsWith('https://')) {
    return filenameOrUrl;
  }

  // Check if there's a mapped version (for files that exist with underscores)
  // Otherwise use the original filename and let encodeURIComponent handle URL encoding
  const safeFilename = FILENAME_MAP[filenameOrUrl] || filenameOrUrl;

  // Return local path with proper URL encoding
  // encodeURIComponent will convert spaces to %20, parentheses to %28/%29, etc.
  return `/asset_images/${encodeURIComponent(safeFilename)}`;
}

/**
 * Get the URL for an asset image
 * Alias for getAssetImageUrlFromClient
 */
export function getAssetImageUrl(filename) {
  return getAssetImageUrlFromClient(filename);
}

export default getAssetImageUrlFromClient;
